import React from "react";

// Padding scales with role, per source: p-4 list/grid card, p-5 KPI/chart/
// panel, p-6 standalone form card (ADMIN_DESIGN_SYSTEM.md "Card pattern").
const PADDING = { sm: "p-4", md: "p-5", lg: "p-6" };

export default function AdminCard({ padding = "md", className = "", children, ...props }) {
  return (
    <div {...props} className={`rounded-2xl bg-white border border-[#E5DFC8] ${PADDING[padding]} ${className}`}>
      {children}
    </div>
  );
}
